<template>
    <div class="chart">
        <div class="chart-content">
            <div class="title">
                Capital needed
            </div>
            <div class="value">
               {{ capitalNeeded }}
            </div>
            <div class="in-return-for">
                In return for
            </div>
            <div class="in-return-value">
                {{ (graphData.in_return_for) }}%
            </div>
        </div>
        <canvas ref="chart" width="400" height="400"></canvas>
    </div>
</template>

<script>
    import Chart from 'chart.js';
    import {CHART_COLORS} from "./chartColors";
    import {formatMoney} from "../../utils";

    export default {
        name: 'investmentPercentageGraph',
        data() {
            let data = this.data;
            return {
                capitalNeeded: formatMoney(data.capital_needed),
                graphData: data,
            }
        },
        props: ['data'],
        mounted() {
            let config = {
                type: 'doughnut',
                data: {
                    datasets: [{
                        data: [
                            this.graphData.in_return_for,
                            100 - (this.graphData.in_return_for)
                        ],
                        backgroundColor: [
                            CHART_COLORS.MAIN,
                            CHART_COLORS.SECONDARY,
                        ],
                        label: 'Dataset 1',
                        borderWidth: 0
                    }],
                    labels: [
                        'In return for',
                        '',
                    ]
                },
                options: {
                    cutoutPercentage: 70,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            left: 20,
                            right: 20,
                            top: 20,
                            bottom: 20
                        }
                    },
                    responsive: true,
                    legend: {
                        display: false,
                        position: 'bottom',
                    },
                    title: {
                        display: false,
                        text: 'Shareholders'
                    },
                    animation: {
                        animateScale: true,
                        animateRotate: true
                    },
                    tooltips: {
                        enabled: true,
                        callbacks: {
                            label: function (tooltipItem, data) {
                                var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || '';
                                var label = data.labels[tooltipItem.index]
                                return `${label} ${value}%`;
                            }
                        }
                    },
                    scales: {}
                }
            };
            var myChart = new Chart(this.$refs.chart, config);
        },
        methods: {},
        computed: {},
    }
</script>

<style scoped lang="scss">
    @import "../../../sass_old/vars";
    .chart {
        position: relative;
        height: 400px;
        width: 100%;

        .chart-content {
            position: absolute;
            z-index: 1;
            left: 0px;
            top: 135px;
            width: 100%;
            text-align: center;
        }

        .title {
            font-size: 26px;
        }

        .value {
            font-size: 26px;
            font-weight: bold;
        }

        .in-return-for {
            color: $primary;
            font-size: 22px;
        }

        .in-return-value {
            color: $primary;
            font-size: 22px;
            font-weight: bold;
        }

        canvas {
            border: none;
            z-index: 0;
            height: 400px;
            width: 400px;
            position: absolute;
            top: 0;
            left: 0;
        }
    }
</style>
